/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for evaluation monitoring job.

Scans for overdue evaluations and sends reminders to lecturers and reports to admins.
 */
export interface EvaluationMonitoringParams {
  [key: string]: unknown;
}
